var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "my-tooltip" }, [
    _c(
      "span",
      {
        attrs: { "data-toggle": "tooltip" },
        on: {
          mouseenter: function($event) {
            _vm.show = true
          },
          mouseleave: function($event) {
            _vm.show = false
          }
        }
      },
      [_vm._t("default")],
      2
    ),
    _vm._v(" "),
    _vm.show
      ? _c(
          "div",
          {
            staticClass: "tooltip bs-tooltip-top show",
            attrs: { role: "tooltip" }
          },
          [
            _c("div", { staticClass: "arrow" }),
            _vm._v(" "),
            !_vm.slotTooltipInner
              ? _c("div", {
                  staticClass: "tooltip-inner",
                  domProps: { innerHTML: _vm._s(_vm.text) }
                })
              : _c(
                  "div",
                  { staticClass: "tooltip-inner" },
                  [_vm._t("tooltip-inner")],
                  2
                )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }